import React from 'react';

import { useWorkflowBuilderReducer, WorkflowBuilderContext } from './builder-context';
import { WorkflowCampaignWizard } from './wizard';

type WorkflowCampaignBuilderProps = {
  isOpen: boolean;
  onClose: () => void;
};

export function WorkflowCampaignBuilder({ isOpen, onClose }: WorkflowCampaignBuilderProps) {
  const builderReducer = useWorkflowBuilderReducer();

  return (
    <WorkflowBuilderContext.Provider value={builderReducer}>
      <WorkflowCampaignWizard open={isOpen} onClose={onClose} />
    </WorkflowBuilderContext.Provider>
  );
}
